import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["individualCriteria", "entityCriteria", "entityTypeField", "entityName", "entityName2", "entityName3"]

  connect() {
    // Listen for when this step becomes visible
    this.element.addEventListener('step:visible', this.onStepVisible.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('step:visible', this.onStepVisible.bind(this))
  }

  onStepVisible(event) {
    // Sync entity type and account name from Step 2
    this.syncFromInvestorInfo()
    this.toggleCriteria()
  }

  syncFromInvestorInfo() {
    // Get entity type from Step 2
    const investorEntityTypeRadio = document.querySelector('input[name*="[investor_account_attributes][entity_type]"]:checked')
    if (investorEntityTypeRadio) {
      const entityType = investorEntityTypeRadio.value
      // Set the hidden field value for accreditation entity type
      this.entityTypeFieldTarget.value = entityType
    }

    // Get account name from Step 2
    const accountNameField = document.querySelector('input[name*="[investor_account_attributes][name]"]')
    if (accountNameField && accountNameField.value && this.hasEntityNameTarget) {
      const accountName = accountNameField.value
      // Update all entity name placeholders
      this.entityNameTargets.forEach(target => {
        target.textContent = accountName
      })
      if (this.hasEntityName2Target) {
        this.entityName2Targets.forEach(target => {
          target.textContent = accountName
        })
      }
      if (this.hasEntityName3Target) {
        this.entityName3Targets.forEach(target => {
          target.textContent = accountName
        })
      }
    }
  }

  toggleCriteria() {
    // For standalone forms (fund invitation), read from radio buttons
    const entityTypeRadio = document.querySelector('input[name="entity_type"]:checked')
    let entityType = "individual"

    if (entityTypeRadio) {
      entityType = entityTypeRadio.value
      // Update hidden field if it exists
      if (this.hasEntityTypeFieldTarget) {
        this.entityTypeFieldTarget.value = entityType
      }
    } else if (this.hasEntityTypeFieldTarget) {
      // For multi-step forms, read from hidden field
      entityType = this.entityTypeFieldTarget.value || "individual"
    }

    if (entityType === "individual") {
      this.individualCriteriaTarget.classList.remove("hidden")
      this.entityCriteriaTarget.classList.add("hidden")
      // Uncheck entity criteria
      this.entityCriteriaTarget.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false)
    } else if (entityType === "entity") {
      this.entityCriteriaTarget.classList.remove("hidden")
      this.individualCriteriaTarget.classList.add("hidden")
      // Uncheck individual criteria
      this.individualCriteriaTarget.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false)
    }
  }
}
